export enum StaffPermissionType {
  OPERATOR = 8,
  ADMINISTRATOR = 16
}